<template>
    <div>

        <v-overlay id="geomap-fullscreen-overlay" v-if="($store.getters.fullscreenIsActive && ($store.getters.dialogIsActive))" />

        <div class="map-info-window-expand-button" @click="expandClick">
            <v-icon class="expand-icon" small color="#717171">mdi-arrow-expand</v-icon>
        </div>


        <div class="map-info-window-card" id="map-info-window-card" :class="{sectors: infoWindowData.infoType == 1}" :style="{height: getExpandedHeight(), width: getExpandedWidth()}">

            <div class="site-info-container">
                <div class="site-image-container">
                    <img :src="imageSrc" v-if="imageSrc"/>
                    <span class="no-image-text" v-if="!imageSrc && !gettingSiteImage">No Image Available</span>
                    <v-icon x-large class="site-image-spinner" style="color: #000000;" v-if="gettingSiteImage">fas fa-spinner fa-spin</v-icon>
                </div>
                <div class="site-content-container">
                    <span class="site-name" :class="{disabled: fromChildSiteTable}" @click="goToSite({alarm_site_id: $props.mapItem.siteId})" v-if="$props.mapItem.name">{{$props.mapItem.name}}</span>
                    <span class="site-name" :class="{disabled: fromChildSiteTable}" @click="goToSite({alarm_site_id: $props.mapItem.siteId})" v-if="!$props.mapItem.name">{{`${$props.mapItem.office} ${$props.mapItem.location}`}}</span>
                    <v-btn v-if="!$props.mapItem.isLink" title="Navigate to Site" color="#168AE2" outlined x-small fab absolute class="ml-2" @click="navigate"><v-icon>mdi-navigation</v-icon></v-btn>
                    <v-btn-toggle class="ml-12" v-model="infoWindowData.infoType" mandatory light color="#c42111">
                        <v-btn height="36" width="40" min-width="40"><v-icon color="#c42111" small>mdi-bell-ring</v-icon></v-btn>
                        <v-btn height="36" width="40" min-width="40"><v-icon color="#c42111" small>mdi-radioactive</v-icon></v-btn>
                        <v-btn height="36" width="40" min-width="40"><v-icon color="#c42111" small>mdi-table</v-icon></v-btn>
                        <v-btn height="36" width="40" min-width="40"><v-icon color="#c42111" small>mdi-chart-line</v-icon></v-btn>
                    </v-btn-toggle>

                    <div class="site-info">
                        <span class="label">Office: </span>
                        {{$props.mapItem.office}}
                        <br>
                        <span class="label">Location: </span>
                        {{$props.mapItem.location}}
                        <br>
                        <span class="label">Locale: </span>
                        {{$props.mapItem.locale}}
                    </div>
                </div>
                <div class="alarm-text-container">
                    <span class="alarm-text" :class="{blink: !!$props.mapItem.alarms.length}" :style="{color: mostSevereColor}">
                        {{`${$props.mapItem.alarms.length ? $props.mapItem.alarms.length : 'No'} Active Alarm${$props.mapItem.alarms.length == 1 ? '' : 's'}`}}
                    </span>
                    <span class="disregarded-alarms-text" @click="showDisregardedAlarmsList = true" v-if="$props.mapItem.disregardAlarmsList && $props.mapItem.disregardAlarmsList.length">{{`${$props.mapItem.disregardAlarmsList.length} Disregarded Alarms`}}</span>
                </div>
            </div>

            <v-window class="map-info-window-card-window-container" v-model="infoWindowData.infoType" style="margin-top: 10px;" :style="{height: expanded ? 'calc(100% - 138px)' : 'calc(100% - 90px)'}">
                <v-window-item :key="0" style="height: 100%;">
                    <div class="alarms-section" style="height: 100%;" v-if="!!$props.mapItem.alarms.length || true">
                        <alarms-list :alarms="$props.mapItem.alarms" :alarmGridResources="$props.alarmGridResources" eid="ag-grid-map-item-alarms-container" v-if="showAlarms" />
                    </div>
                </v-window-item>

                <v-window-item :key="1" style="height: 100%;">
                    <div class="sectors-container">
                        <div class="getting-data-container" v-if="gettingSiteData">
                            <v-icon x-large dark class="site-image-spinner">fas fa-spinner fa-spin</v-icon>
                        </div>
                        <div v-if="!gettingSiteData">
                            <div class="sector-info" :style="{height: expanded ? '100%' : '242px'}">
                                <v-simple-table light dense height="100%" style="min-height: 160px;">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Num</th>
                                            <th class="text-left">Name</th>
                                            <th class="text-left">MSCID</th>
                                            <th class="text-left">Azimuth</th>
                                            <th class="text-left">On Air Time</th>
                                            <th class="text-left">Decomm Time</th>
                                            <th class="text-left">Coverage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- <tr v-for="sector in siteData.sectors" :class="{highlight: (sector.sect_azimuth == highlightedSectorAzimuth), disabled: sectorDisabled(sector)}"> -->
                                        <tr v-for="sector in siteData.sectors" :class="{highlight: (sector.sect_azimuth == highlightedSectorAzimuth), disabled: sectorDisabled(sector)}" :style="{'background-color': sector.sect_azimuth == highlightedSectorAzimuth ? sector.mostSevereColor : ''}">
                                            <td>{{ sector.sect_num }}</td>
                                            <td>{{ sector.sect_name }}</td>
                                            <td>{{ sector.sect_mscid }}</td>
                                            <td><b>{{ sector.sect_azimuth }}</b></td>
                                            <td>{{ sector.sect_on_air_time }}</td>
                                            <td>{{ sector.sect_decomm_time }}</td>
                                            <td>
                                                <v-btn min-width="105px" width="105px" height="15px" x-small @click="$emit('showCoverage', [sector.sect_id])" :disabled="!sectorsWithCoverageData.includes(sector.sect_id)" v-if="!$props.activeCoverageSectIds.includes(sector.sect_id)">show coverage</v-btn>
                                                <v-btn min-width="105px" width="105px" height="15px" x-small @click="$emit('hideCoverage', [sector.sect_id])" v-else>hide coverage</v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>

                            <div class="sector-azimuth">
                                <svg viewBox="0 0 24 24">
                                    <g class="center"><path d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2" /></g>
                                    <template v-for="sector in siteData.sectors">
                                        <!-- <g class="sec" :class="{disabled: sectorDisabled(sector)}" @mouseover="highlightSector(sector.sect_azimuth)" @mouseout="highlightSector(null)" :transform="`rotate(${180 + sector.sect_azimuth} 12 12) scale(1)`"><path d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53" /></g> -->
                                        <g class="sec" :style="{fill: sector.mostSevereColor, 'fill-opacity': sector.alarmCount ? 1 : 0.3}" :class="{disabled: sectorDisabled(sector)}" @mouseover="highlightSector(sector.sect_azimuth)" @mouseout="highlightSector(null)" :transform="`rotate(${180 + sector.sect_azimuth} 12 12) scale(1)`"><path d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53" /></g>
                                    </template>
                                </svg>
                            </div>
                        </div>
                    </div>
                </v-window-item>

                <v-window-item :key="2" style="height: 100%;">
                    <map-item-site-threshold-metrics :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" :infoWindowData="infoWindowData" />
                </v-window-item>

                <v-window-item :key="3" style="height: 100%;">
                    <map-item-site-threshold-metrics-chart :infoWindowData="infoWindowData" :gettingSiteThresholdMetrics="gettingSiteThresholdMetrics" />
                </v-window-item>
            </v-window>

        </div>




        <v-dialog v-model="showDisregardedAlarmsList" max-width="80%" width="1200px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showDisregardedAlarmsList = false : null}">
            <disregarded-alarms-list v-if="showDisregardedAlarmsList" :alarms="$props.mapItem.disregardAlarmsList ? $props.mapItem.disregardAlarmsList : []" :alarmGridResources="alarmGridResources" @close="showDisregardedAlarmsList = false" />
        </v-dialog>

    </div>
</template>

<script>
import AlarmsList from "@/components/Alarms/AlarmsList";
import MapItemSiteThresholdMetrics from "@/components/GeoMap/MapItemSiteThresholdMetrics";
import MapItemSiteThresholdMetricsChart from "@/components/GeoMap/MapItemSiteThresholdMetricsChart";
import DisregardedAlarmsList from "@/components/GeoMap/DisregardedAlarmsList";
export default {
    name: 'MapItemInfoWindow',
    props: ['infoWindowElementCtr', 'map', 'mapItem', 'alarmGridResources', 'activeCoverageSectIds'],
    components: {
        AlarmsList,
        MapItemSiteThresholdMetrics,
        MapItemSiteThresholdMetricsChart,
        DisregardedAlarmsList
    },
    data: () => ({
        showAlarms: true,

        mapItemInfoWindow: null,
        infoWindowElement: null,
        infoWindowOptions: {
            pixelOffset: {width: 0, height: -16},
            content: null,
            maxWidth: 3000,
            minWidth: 750,
            position: null,
        },
        expanded: false,
        infoWindowData: {
            infoType: 0,
            siteId: null,
            siteData: null,
            imageSrc: null,
            siteThresholdMetrics: null,
            siteThresholdMetricsFilters: null,
            filteredSiteThresholdMetrics: null,
            siteThresholdMetricsGroupByType: null
        },
        gettingSiteData: true,
        siteData: null,
        gettingSiteImage: false,
        imageSrc: null,
        showSectorsInfo: true,
        highlightedSectorAzimuth: null,
        gettingSiteThresholdMetrics: true,
        showDisregardedAlarmsList: false,

        sectorsWithCoverageData: [],
    }),

    computed: {
        mostSevereColor() {
            let color = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.normal.background;
            if(this.$props.mapItem.criticalCount) {
                color = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.critical.background;
            }
            else if(this.$props.mapItem.majorCount) {
                color = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.major.background;
            }
            else if(this.$props.mapItem.minorCount) {
                color = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.minor.background;
            }
            else if(this.$props.mapItem.observationalCount) {
                color = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.observational.background;
            }
            // else if(this.$props.mapItem.defaultCount) {
            //     color = this.$state.batchConfig.webapp_settings.alarms.alarmColors.geographical.default.background;
            // }

            return color;
        },

        fromChildSiteTable() {
            return this.$props.mapItem.sourceTable != 'sites';
        }
    },

    methods: {
        expandClick: function() {
            this.expanded = !this.expanded;
            this.$nextTick(() => {
                this.mapItemInfoWindow.setContent(this.$el);
                this.$props.map.panTo(this.mapItemInfoWindow.getPosition());
                let amt = ((document.getElementById('js-geomap').offsetHeight - 60) / 2) * -1;
                this.$props.map.panBy(0, amt);

                document.getElementById('ag-grid-map-item-alarms-container').style.height = this.expanded ? `${document.getElementById('js-geomap').offsetHeight - 290}px` : '265px';
            });
        },

        getExpandedHeight: function() {
            return this.expanded ? `${document.getElementById('js-geomap').offsetHeight - 120}px` : `376px`;
        },

        getExpandedWidth() {
            return this.expanded ? `${document.getElementById('js-geomap').offsetWidth - 120}px` : `750px`;
        },

        getSiteData: function() {
            this.gettingSiteData = true;
            let route = (`${TELSA.apiHost}sites/site/${this.$props.mapItem.siteId}`);
            this.$http.get(route).then(response => {
                let result = response.body;
                this.siteData = result.site;
                this.setSectorMostSevereAlarmColor();
                this.checkSectorsForCoverageData();
                this.infoWindowData.siteData = result.site;
                this.gettingSiteData = false;
            });
        },

        getSiteImage: function() {
            this.gettingSiteImage = true;
            let route = (`${TELSA.apiHost}site/image/${this.$props.mapItem.siteId}`);
            return this.$http.get(route).then(response => {
                let result = response.body;
                if(result) {
                    this.imageSrc = result;
                    this.infoWindowData.imageSrc = result;
                }
                else {
                    this.imageSrc = null;
                }
                this.gettingSiteImage = false;
            });
        },

        navigate: function() {
            this.$emit('navigate');
        },

        goToSite: function(alarm) {
            if(this.fromChildSiteTable) {
                return;
            }
            if(this.$store.state.isDirty) {
                TELSA.loading(false);
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your Map Views changes without saving?',
                    type: 'warning',
                    confirmAction: () => {
                        this.$store.commit('setIsDirty', false);
                        this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                        this.$router.push('sites');
                    }
                });
            }
            else {
                this.$store.commit('setEditSiteFromAlarmShortcut', alarm);
                this.$router.push('sites');
            }
        },

        highlightSector: function(azimuth) {
            this.highlightedSectorAzimuth = azimuth;
        },

        sectorDisabled: function(sector) {
            if(sector.sect_on_air_time && (TELSA.moment.tz(this.$store.state.batchConfig.timezone) < TELSA.moment(sector.sect_on_air_time))) {
                return true;
            }
            if(sector.sect_decomm_time && (TELSA.moment.tz(this.$store.state.batchConfig.timezone) > TELSA.moment(sector.sect_decomm_time))) {
                return true;
            }
            return false;
        },

        getSiteThresholdMetrics: function() {
            let route = (TELSA.apiHost + "sites/site/thresholdmetrics");
            this.gettingSiteThresholdMetrics = true;
            return this.$http.post(route, {args: {sites: [{siteOffice: this.$props.mapItem.office, siteLocation: this.$props.mapItem.location, siteThresholdMetrics: []}]}}).then(response => {
                let result = response.body;
                if(result && result.length && result[0].siteThresholdMetrics) {
                    this.infoWindowData.siteThresholdMetrics = result[0].siteThresholdMetrics;
                    this.infoWindowData.filteredSiteThresholdMetrics = result[0].siteThresholdMetrics;
                }
                this.gettingSiteThresholdMetrics = false;
            });
        },

        getInfoWindowData: function() {
            let persistentDataExists = (this.infoWindowData.siteId == this.$props.mapItem.siteId);

            if(persistentDataExists && this.infoWindowData.siteData) {
                this.siteData = this.infoWindowData.siteData;
                this.gettingSiteData = false;
            } else {
                this.getSiteData();
            }
            if(persistentDataExists && this.infoWindowData.imageSrc) {
                this.imageSrc = this.infoWindowData.imageSrc;
            } else {
                this.getSiteImage();
            }
            if(persistentDataExists && this.infoWindowData.siteThresholdMetrics) {
                this.gettingSiteThresholdMetrics = false;
            } else {
                this.getSiteThresholdMetrics();
            }
            this.infoWindowData.siteId = this.$props.mapItem.siteId;
        },

        setSectorMostSevereAlarmColor: function(sector) {
            for(let sector of this.siteData.sectors || []) {
                sector.criticalCount = 0;
                sector.majorCount = 0;
                sector.minorCount = 0;
                sector.observationalCount = 0;
                sector.alarmCount = 0;
                for(let alarm of this.$props.mapItem.alarms) {
                    if(alarm.alarm_sector && alarm.alarm_sector == sector.sect_id) {
                        if(alarm.alarm_severity == 'CRITICAL') {
                            sector.criticalCount++;
                        }
                        else if(alarm.alarm_severity == 'MAJOR') {
                            sector.majorCount++;
                        }
                        else if(alarm.alarm_severity == 'MINOR') {
                            sector.minorCount++;
                        }
                        else if(alarm.alarm_severity == 'OBSERVATIONAL') {
                            sector.observationalCount++;
                        }
                        sector.alarmCount++;
                    }
                }
                if(sector.criticalCount > 0) {
                    sector.mostSevereColor = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.critical.background;
                }
                else if(sector.majorCount > 0) {
                    sector.mostSevereColor = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.major.background;
                }
                else if(sector.minorCount > 0) {
                    sector.mostSevereColor = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.minor.background;
                }
                else if(sector.observationalCount > 0) {
                    sector.mostSevereColor = this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.observational.background;
                }
                else {
                    sector.mostSevereColor = '#c42111';
                }
            }
        },

        handleAlarmUpdates(mapItem) {
            if(this.$props.mapItem.alarms.length != mapItem.alarms.length) {
                this.showAlarms = false;
                this.$nextTick(() => {
                    this.showAlarms = true;
                });
                this.$props.mapItem.criticalCount = mapItem.criticalCount;
                this.$props.mapItem.majorCount = mapItem.majorCount;
                this.$props.mapItem.minorCount = mapItem.minorCount;
                this.$props.mapItem.observationalCount = mapItem.observationalCount;
            }
            this.$props.mapItem.alarms = mapItem.alarms;
        },

        checkSectorsForCoverageData() {
            for(let sector of this.siteData.sectors) {
                let sectorId = sector.sect_id;
                TELSA.IDB.getAllViaIndex('geoMapCoverageDataStore', 'sectorIdIndex', sectorId).then(results => {
                    if(Array.isArray(results) && results.length > 0) {
                        this.sectorsWithCoverageData.push(sectorId);
                    }
                });
            }
        }
    },

    watch: {
        mapItem: {
            handler(newVal, oldVal) {
                if(newVal.siteId != oldVal.siteId) {
                    // They selected a new site.
                    this.mapItemInfoWindow.setPosition(this.$props.mapItem.position);
                    this.getInfoWindowData();
                    this.showAlarms = false;
                    this.$nextTick(() => {
                        this.showAlarms = true;
                    });
                }
                else {
                    this.mapItemInfoWindow.setPosition(this.$props.mapItem.position);
                }
            },
            deep: true
        }
    },

    mounted() {
        this.mapItemInfoWindow.setPosition(this.$props.mapItem.position);
        this.mapItemInfoWindow.setContent(this.$el);
        this.mapItemInfoWindow.open({map: this.$props.map});
        this.getInfoWindowData();
    },

    created() {
        this.infoWindowOptions.pixelOffset.height = this.mapItem.isLink ? 0 : -8;
        this.mapItemInfoWindow = new this.$props.infoWindowElementCtr(this.infoWindowOptions);
        this.mapItemInfoWindow.addListener('close', () => {
            this.$emit('close');
        });
    },

    destroyed() {
        this.mapItemInfoWindow.close();
    }
};
</script>

<style scoped>

    .map-info-window-expand-button {
        position: absolute;
        right: 40px;
        top: 10px;
        cursor: pointer;
        z-index: 2;
    }
    .map-info-window-expand-button:hover .expand-icon {
        color: #000000 !important;
    }

    .map-info-window-card {
        color: #000000;
        position: relative;
        width: 100%;
        padding: 10px;
    }
    .map-info-window-card.sectors {
        min-height: 280px;
    }

    .site-info-container {
        height: 90px;
        display: block;
    }

    .site-image-container {
        margin-right: 10px;
        width: 96px;
        height: 96px;
        display: inline-block;
        position: relative;
    }

    .site-image-container img {
        width: 96px;
        height: 96px;
    }

    .site-image-container .no-image {
        width: 100%;
        height: 100%;
        font-size: 80px;
    }
    .site-image-container .no-image-text {
        width: 100%;
        height: 100%;
        font-size: 18px;
        margin-top: 15px;
        display: block;
        text-align: center;
    }

    .site-image-spinner {
        width: 96px;
        height: 96px;
    }

    .site-content-container {
        overflow: hidden;
        display: inline-block;
        max-width: calc(100% - (96px + 10px));
        width: calc(100% - (96px + 10px));
        vertical-align: top;
    }

    .site-name {
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
        cursor: pointer;
        color: #0645ad;
        text-decoration: underline;
    }
    .site-name.disabled {
        color: #000000;
        cursor: default;
        text-decoration: none;
    }

    .site-info {
        overflow-x: auto;
    }

    .site-info .label {
        font-weight: 500;
    }


    .alarm-text-container {
        text-align: center;
        display: block;
        top: 45px;
        right: 30px;
        position: absolute;
    }
    .alarm-text-container .alarm-text {
        text-transform: uppercase;
        font-size: 16pt;
        font-weight: bold;
    }
    .alarm-text-container .alarm-text.blink {
        animation:blinkingText 1s step-start infinite;
    }
    @keyframes blinkingText{
        0%{}
        50%{color: #000;}
    }

    .alarm-text-container .alarm-icon {
        color: #000000;
        cursor: pointer;
        vertical-align: top;
    }

    .disregarded-alarms-text {
        cursor: pointer;
        text-decoration: underline;
        display: block;
    }

    .alarms-section {
        min-height: 260px;
    }

    #ag-grid-map-info-alarms-container {
        height: 100%;
    }

    .view-sectors-button {
        z-index: 11;
    }

    .getting-data-container i {
        color: #000000;
        position: absolute;
        z-index: 2;
        left: calc(50% - (96px / 2));
        margin-top: 80px;
    }

    .view-sectors-button .sectors-arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid #c42111;
        top: 20px;
        z-index: 12;
    }
    .view-sectors-button .sectors-arrow .inner {
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #ffffff;
        position: absolute;
        left: -12px;
        top: 3px;
        z-index: 13;
    }

    .sectors-container {
        width: 100%;
        border: #BDC3C7 solid 1px;
        position: relative;
        background-color: #ffffff;
        z-index: 1;
        text-align: center;
    }

    .sectors-container .sector-info {
        z-index: 10;
        display: inline-block;
        width: calc(100% - 150px - 4px);
        overflow-y: auto;
    }
    .sectors-container .sector-info .highlight {
        /* background-color: #c42111; */
        color: #ffffff;
    }
    .sectors-container .sector-info .highlight.disabled {
        background-color: #808080 !important;
        color: #ffffff;
    }

    .sectors-container .sector-azimuth {
        position: relative;
        display: inline-block;
        width: 150px;
        float: right;
    }
    .sectors-container .sector-azimuth svg {
        height: 150px;
        width: 150px;
    }

    .sectors-container .sector-azimuth .center {
        fill: #c42111;
        fill-opacity: 1;
        stroke: #000000;
        stroke-width: 0.1px;
    }

    .sectors-container .sector-azimuth .sec {
        /* fill: #c42111; */
        stroke: #000000;
        stroke-width: 0.1px;
        /* fill-opacity: 0.3; */
        cursor: pointer;
    }
    .sectors-container .sector-azimuth .sec.disabled {
        fill: #808080 !important;
    }

    .sectors-container .sector-azimuth .sec:hover {
        fill-opacity: 1;
    }

</style>


<style>
    #ag-grid-map-item-alarms-container {
        height: 265px;
        /* height: 240px; */
    }

    #ag-grid-map-item-alarms-container .ag-row-hover {
        /* putting in !important so it overrides the theme's styling as it hovers the row also */
        background-color: #c8e6c9 !important;
    }

    #ag-grid-map-item-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    #telsasoft-application .ag-theme-balham.ag-popup {
        z-index: 6;
    }

    .map-info-window-card-window-container .v-window__container {
        position: relative;
        height: 100%;
    }

    .gm-style-iw-chr {
        height: 0px;
    }
    .gm-style-iw-chr  button {
        position: absolute;
        right: 8px;
        top: 7px;
        width: 24px !important;
        height: 24px !important;
        z-index: 1;
        outline: none;
    }
    .gm-style-iw-chr  button span {
        margin: 0px !important;
    }

</style>
